module.exports = __webpack_public_path__ + "img/icloud.3eed8068.png";